import { branch, compose, getContext, renderNothing, mapProps } from 'recompose'
import { isFunction } from 'lodash'
import { CONTEXT } from './WizardProvider'

const WizardClient = compose(
  getContext(CONTEXT),
  branch(
    ({ step, currentStep }) => step && step !== currentStep,
    renderNothing
  ),
  branch(
    ({ children }) => isFunction(children),
    () => ({ children, ...props }) => children(props),
    mapProps(({ children }) => ({ children }))
  )
)

export default WizardClient
